import classnames from 'classnames';
import type { FunctionComponent } from 'react';
import { translate } from '@/domains/core/localization/translate';
import { RoundFrance } from '@/domains/core/tamagoshi/icons/RoundFrance';
import styles from './LocalLabel.module.scss';
const {
  label
} = translate({
  "label": "Made in the UK"
});
interface LocalLabelProps {
  className?: string;
  reversed?: boolean;
}
export const LocalLabel: FunctionComponent<LocalLabelProps> = ({
  className,
  reversed = false
}) => {
  const rootClassnames = classnames(styles.root, {
    [styles.reversed]: reversed
  }, className);
  return <div className={rootClassnames}>
      {label}
      <RoundFrance width={18} height={18} />
    </div>;
};
LocalLabel.displayName = 'LocalLabel';